import { Injectable } from "@angular/core";
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from "@angular/common/http";
import { Observable } from "rxjs";
import { AuthService } from "../services/auth.service";
import { environment } from "../../../environments/environment";

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(private auth: AuthService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // 1) No tocar estáticos
    if (req.url.includes("/assets/") || req.url.includes("/i18n/")) {
      return next.handle(req);
    }

    // 2) No duplicar header si ya viene (Swagger o casos especiales)
    if (req.headers.has("Authorization")) {
      return next.handle(req);
    }

    // 3) Detectar si es request a tu backend (mismo host del baseUrl)
    const token = this.auth.getToken();
    if (!token) return next.handle(req);

    const base = environment.baseUrl; // ej: http://localhost:3000 o http://localhost:3000/api/v1
    const baseHost = this.safeHost(base);
    const reqHost = this.safeHost(req.url);

    const isRelative = req.url.startsWith("/");
    const isSameHost = !!baseHost && !!reqHost && baseHost === reqHost;

    // si es relativa la consideramos API (en tu app casi siempre lo es)
    // si es absoluta, solo si va al mismo host del backend
    const isApi = isRelative || isSameHost;

    if (!isApi) return next.handle(req);

    // 4) No agregar token a auth endpoints
    if (req.url.includes("/auth/login") || req.url.includes("/auth/token")) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      })
    );
  }

  private safeHost(url: string): string | null {
    try {
      // si viene relativa, no tiene host
      if (url.startsWith("/")) return null;
      return new URL(url).host;
    } catch {
      return null;
    }
  }
}
